import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { getStorageInstance } from "./config";

const STORAGE_PATH = "clinic-cms/uploads";

export const uploadImage = async (file: File): Promise<string> => {
  try {
    const storage = getStorageInstance();
    const filename = `${Date.now()}-${file.name.replace(/[^a-zA-Z0-9.-]/g, "_")}`;
    const storageRef = ref(storage, `${STORAGE_PATH}/${filename}`);

    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);

    return downloadURL;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw new Error("Failed to upload image. Please try again.");
  }
};

export const deleteImage = async (url: string): Promise<void> => {
  try {
    const storage = getStorageInstance();
    // Extract path from URL
    const urlObj = new URL(url);
    const path = decodeURIComponent(urlObj.pathname.split("/o/")[1]?.split("?")[0] || "");

    if (path) {
      const storageRef = ref(storage, path);
      await deleteObject(storageRef);
    }
  } catch (error) {
    console.error("Error deleting image:", error);
  }
};
